import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import * as types from './types';
import { fetchWishlist, addWishlistItem as _addWishlistItem, deleteWishlistItem as _deleteWishlistItem } from '~/services/wishlist';
export default {
  fetchWishlistItems: function () {
    var _fetchWishlistItems = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, _ref2, wishlist;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return fetchWishlist(this);

            case 3:
              _ref2 = _context.sent;
              wishlist = _ref2.wishlist;
              commit(types.SET_WISHLIST_ITEMS, wishlist);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchWishlistItems(_x) {
      return _fetchWishlistItems.apply(this, arguments);
    }

    return fetchWishlistItems;
  }(),
  addWishlistItem: function () {
    var _addWishlistItem2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref3, reference) {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              _context2.prev = 1;
              _context2.next = 4;
              return _addWishlistItem(this, reference);

            case 4:
              commit(types.ADD_WISHLIST_ITEM, {
                product: {
                  reference: reference
                }
              });
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              this.$logger.error(_context2.t0);
              throw new Error('ADD_WISHLIST_FAILED');

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7]]);
    }));

    function addWishlistItem(_x2, _x3) {
      return _addWishlistItem2.apply(this, arguments);
    }

    return addWishlistItem;
  }(),
  deleteWishlistItem: function () {
    var _deleteWishlistItem2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref4, reference) {
      var commit;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref4.commit;
              _context3.prev = 1;
              _context3.next = 4;
              return _deleteWishlistItem(this, reference);

            case 4:
              commit(types.DELETE_WISHLIST_ITEM, reference);
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              this.$logger.error(_context3.t0);
              throw new Error('REMOVE_WISHLIST_FAILED');

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[1, 7]]);
    }));

    function deleteWishlistItem(_x4, _x5) {
      return _deleteWishlistItem2.apply(this, arguments);
    }

    return deleteWishlistItem;
  }()
};